import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import MessagingLabel from 'LuxKit/Label/MessagingLabel'
import Modal from 'LuxKit/Modal/Modal'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { getCruiseVendorBookingTimer } from 'lib/cruises/cruiseUtils'
import { useCallback, useContext, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { getRemainingCruiseSessionTime } from './utils'

function CruiseSessionCountdownMessage() {
  const intl = useIntl()
  const [timeRemaining, setTimeRemaining] = useState(getRemainingCruiseSessionTime())

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(getRemainingCruiseSessionTime())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const showModal = useContext(ModalContext)

  const openInfoModal = useCallback(() => {
    const timer = getCruiseVendorBookingTimer()
    showModal(<Modal title={intl.formatMessage({
      id: 'sMD2m_CeaPvdONa8u_rW',
      defaultMessage: 'Cruise prices',
      description: 'Modal title for cruise session countdown information',
    })}
    >
      <BodyText variant="large">
        {intl.formatMessage(
          {
            id: '0n7Aw1l8cwRRFJiTmGvV',
            defaultMessage: 'Due to demand and availability, cruise prices can fluctuate quickly. We can hold your cruises for a {timer} minute period before your session expires. Hurry and book now before prices increase!',
            description: 'Explanation of cruise price hold period and urgency to book',
          },
          { timer },
        )}
      </BodyText>
    </Modal>)
  }, [intl, showModal])

  return <Group direction="horizontal" verticalAlign="center" horizontalAlign="center" gap={8} wrap="wrap">
    <BodyTextBlock variant="medium" endIcon={<Clickable onClick={openInfoModal}><LineInfoCircleIcon /></Clickable>}>
      {intl.formatMessage(
        {
          id: 'bDBxpyJGURdNTyYE-24i',
          defaultMessage: 'Cruise prices held for {timer} minutes',
          description: 'Label indicating cruise prices are held for a specified number of minutes',
        },
        { timer: getCruiseVendorBookingTimer() },
      )}
    </BodyTextBlock>
    <MessagingLabel variant="urgency">
      {intl.formatMessage(
        {
          id: 't8ORHIGn0sJyAag0gP8L',
          defaultMessage: '{minutes} : {seconds} remaining',
          description: 'Countdown timer showing minutes and seconds remaining for cruise session',
        },
        { minutes: timeRemaining.minutes, seconds: timeRemaining.seconds },
      )}
    </MessagingLabel>
  </Group>
}

export default CruiseSessionCountdownMessage
